import _ from "underscore";

export function pagination(items, tableInfo) {
  if (!tableInfo.pagination) return items;

  return _.take(
    _.drop(items, (tableInfo.pagination.page - 1) * tableInfo.pagination.take),
    tableInfo.pagination.take,
  );
}

export default pagination;
